<ngx-ui-loader></ngx-ui-loader>

<div class="monitoring-wrap">
  <div class="monitoring-head">
    <h2>
      {{globalService && globalService.selectedOrder && globalService.selectedOrder['mainApp']?globalService.selectedOrder['mainApp']:''}}
    </h2>
    <a href="javascript:void(0)" (click)="forPopupOpen('addCard','','')" class="btn btn-dark btn-add"><span>+</span>
      Add Card</a>
    <app-addcard [cardName]="'monitoring'"  *ngIf="cardType && (globalService.showPopUp==cardType['addCard'])"
      (valueChange)="valueChangeEvent($event)">
    </app-addcard>
  </div>
  <div class="cards-wrapper clearfix">
    <div class="media-card-wrap" *ngFor="let list of cardData.slice(0,5);let i=index;">
      <ng-container *ngIf="globalService.showTrue">
        <app-card-component [listData]="list" [index]="i+1" *ngIf="i<5" [units]="unitscards" [cardName]="'monitoring'"
          (valueChange)="valueChangeEvent($event)">
        </app-card-component>
      </ng-container>
    </div>
    <a href="javascript:void(0)" class="btn-more" *ngIf="cardData.length>5"
      (click)="forPopupOpen('viewMore','','')">view more <img src="assets/images/arrow.svg" alt=""></a>
    <app-viewallcard (updatePosition)="valueChangeEvent($event)" [cardName]="'monitoring'"
      *ngIf="cardType && (globalService.showPopUp==cardType['viewMore'])">
    </app-viewallcard>
  </div>
</div>
<div class="page-wrap">
  <div class="page-head-outer" id="outerDiv">
    <span class="page-prev" *ngIf="showSIdeButtonsPage" (click)="clickToScroll('prev')"><img
        src="assets/images/arrow.svg" alt=""></span>
    <ng-scrollbar [track]="'horizontal'" [visibility]="'hover'" #typeScroll>
      <div class="page-head">

        <div class="page-head-data">
          <ng-container *ngFor="let content of pageDataArray; let ind  = index;">
            <div class="current-page" [ngClass]="{'current' :(ind==isCurrentTab)}" (click)="showCurrenttab($event,ind)">
              <input type="text" class="page-count" id="page-name{{ind+1}}"   [(ngModel)]="content['pageName']" (ngModelChange)="this.pageRenameUpdate.next($event)" placeholder="Page {{ind+1}}">
              <a href="javascript:void(0)" (click)="close(ind)" class="close"><img src="assets/images/close-icon.svg"
                  alt=""></a>
            </div>
          </ng-container>

          <a href="javascript:void(0)" class="add-page" [ngClass]="{'page-disabled' :(openPageAllow)}"
            (click)="addNewPage()">
            <img src="assets/images/plus-icon.svg" alt="">
          </a>

        </div>

      </div>
    </ng-scrollbar>
    <span class="page-next" *ngIf="showSIdeButtonsPage" (click)="clickToScroll('next')"><img
        src="assets/images/arrow.svg" alt=""></span>
  </div>
  <ng-container *ngFor="let obj of pageDataArray;let ind=index">
    <div class="page-frame-wrap monitoring-legend" data-id="{{obj['pageNo']}}" id="obj['pageNo']"
      *ngIf="(ind==isCurrentTab)" [ngClass]="{'current' :(obj['pageNo']==isCurrentTab)}">
      <div class="page-frame">

        <div class="page-graphs">

          <span *ngIf="openPageAllow" class="page-error-msg">{{pageMessage}}</span>
          <ng-container *ngFor="let content of obj['graphs']; let i  = index;">
            <div class="bar-graphs-wrap" id="{{content.graphNo}}" 
              [hidden]="(content.graphNo!=isCurrentTab)">
              <app-distribution *ngIf="content['type']=='Histogram'" [kpiScore]="content['data'].scoreName"
                [guageValue]="content['data']['list']" [xValue]="content['data'].xValue" [checkgraph]="'monitorings'" [GraphTytle]="content['data'].widgetName" [index]="i" [legend]="'false'"
                [pageTab]="obj['pageNo']"></app-distribution>
              <a class="delete-graph" href="javascript:void(0)" *ngIf="content['type']=='Histogram'"
                (click)="forPopupOpen('EditWidget','app-distribution',i)"><img src="assets/images/edit-icon-blue.svg"
                  alt="info"></a>
              <app-editwidget [cardName]="'monitoring'" [listData]="content['data']" [editGraph]="'distribution'"
                [update]="'updatehistogram'" [content]="'deletehistogram'" *ngIf="content['type']=='Histogram' && cardType && (globalService.showPopUp==cardType['EditWidget']) 
                    && app_bargraph && i== matchInd" (valueChange)="valueChangeEvents($event)"></app-editwidget>


              <!-- <app-timeseries *ngIf="content['type']=='TimeSeries'" [kpiScore]="content['data'].scoreName"
                    [guageValue]="content['data'].all" [aggregation]="content['data'].aggregation" [legend]="'false'"
                    [index]="i" [graphcheck]="'monitoring'" [pageTab]="obj['pageNo']"></app-timeseries> -->
              <app-benchmark-timeseries *ngIf="content['type']=='TimeSeries'" [kpiScore]="content['data'].scoreName"
                [guageValue]="content['data'].all" [GraphTytle]="content['data'].widgetName" [units]="unitsgraph" [typeGraph]="content['data'].raw?content['data'].raw:false" [aggregation]="content['data'].aggregation" [legend]="'false'"
                [index]="i" [graphcheck]="'monitoring'" [pageTab]="obj['pageNo']"></app-benchmark-timeseries>

              <a class="delete-graph" href="javascript:void(0)" *ngIf="content['type']=='TimeSeries'"
                (click)="forPopupOpen('EditWidget','app-timeseries',i)"><img src="assets/images/edit-icon-blue.svg"
                  alt="info"></a>

              <app-editwidget [cardName]="'monitoring'" [listData]="content['data']" [editGraph]="'timeSeries'"
                [content]="'deletetimeseries'" [update]="'updatetimeseries'"
                *ngIf="content['type']=='TimeSeries' && cardType && (globalService.showPopUp==cardType['EditWidget']) && app_timeseries && i== matchInd"
                (valueChange)="valueChangeEvents($event)"></app-editwidget>

              <app-compare *ngIf="content['type']=='Compare'" [legend]="'false'" [graphType]="'simple'"
                [kpiScore]="content['data'].scoreName" [GraphTytle]="content['data'].widgetName" [xvalueSequence]="comparexvaluesequence" [typeGraph]="content['data'].raw?content['data'].raw:false" [units]="unitsgraph" [data]="content['data']" [guageValue]="content['data'].list"
                [pageTab]="obj['pageNo']" [graphcheck]="'monitoring'" [index]="i" [xValue]="content['data'].xValue">
              </app-compare>
              <a *ngIf="content['type']=='Compare'" class="delete-graph" href="javascript:void(0)"
                (click)="forPopupOpen('EditWidget','app-bargraphs',i)"><img src="assets/images/edit-icon-blue.svg"
                  alt="info"></a>
              <app-editwidget [cardName]="'monitoring'" [subCompare]="content['data'].graphType"
                [listData]="content['data']" [editGraph]="'compare'" [update]="'updatecompare'"
                [content]="'deletecompare'"
                *ngIf="content['type']=='Compare' && cardType && (globalService.showPopUp==cardType['EditWidget']) && app_bargraphs && i== matchInd"
                (valueChange)="valueChangeEvents($event)">
              </app-editwidget>
            </div>
          </ng-container>

          <div class="addgraph-link" *ngIf="(obj['pageNo']==isCurrentTab) && obj['graphs'].length<2 "
            [ngClass]="{'current' :(ind==isCurrentTab)}">
            <a href="javascript:void(0)" (click)="forPopupOpen('addGraph','','')" class="btn btn-light">Add
              Graph</a>
            <app-addgraph [cardName]="'monitoring'" [index]="obj['pageNo']" [graphName]="graphName"
              *ngIf="cardType && (globalService.showPopUp==cardType['addGraph']) && obj['pageNo']==isCurrentTab"
              (graphValue)="graphValueEvent($event)" (valueChange)="valueChangeEvents($event)"></app-addgraph>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>